import axios from 'axios'
import { jwtDecode } from 'jwt-decode'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { axiosDefaultHeader, dcpBaseUrl } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import { useAuth } from './useAuth'

export interface UserGroupInfo {
  id: string
  groupName: string
  source?: string
}

interface UserGroupListResponse {
  assignedGroups: UserGroupInfo[]
  count: number
}

interface ResultUserGroupList {
  success: boolean
  info?: UserGroupListResponse
  message?: string
}

interface DCPUserGroupGetProps {
  execUserGroupGet: () => Promise<ResultUserGroupList>
  loading: loadStatus
}

// DCP APIからログインユーザーの所属グループ一覧取得
export const useDCPUserGroupGet = (): DCPUserGroupGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execUserGroupGet = async () => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const { sub: userId } = jwtDecode<{ sub: string }>(jwt)

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(
        `${dcpBaseUrl}/users/${userId}/groups`,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }

      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execUserGroupGet, loading }
}
